export default "__VITE_ASSET__D4QHws1o__"